import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { ConfigSettingsService, HostControlDirective, InputError, RegexService } from '@ebeihilfe/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { TextInputComponent } from '../text-input';
import { TranslateService } from '@ngx-translate/core';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';

@Component({
  selector: 'portal-username-input',
  standalone: true,
  imports: [ReactiveFormsModule, TextInputComponent],
  hostDirectives: [HostControlDirective],
  templateUrl: './username-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsernameInputComponent implements OnInit {
  private readonly translateService = inject(TranslateService);
  private readonly configSettingsService = inject(ConfigSettingsService);
  private readonly regexService = inject(RegexService);
  public accessorDirective = inject(HostControlDirective);
  public usernameMatErrors: InputError[] = [
    {
      errorCode: 'required',
      errorMessage: _('validation.personal_number.required'),
    },
    {
      errorCode: 'pattern',
      errorMessage: this.translateService.instant(_('validation.personal_number.pattern'), {
        personalNumberLength: this.configSettingsService.appSettings.personalNumberLength,
      }),
    },
  ];

  public ngOnInit(): void {
    const control = this.accessorDirective.control;
    if (control) {
      control.addValidators([Validators.required, Validators.pattern(this.regexService.getPersonalNumberRegex())]);
    }
  }
}
